import { ReactNode, createContext, useState } from 'react'
import Notification from '../notification/Notification'

const STATES = {
  SUCCESS: 'success',
  ERROR: 'error',
  INFO: 'info'
}

interface NotificationData {
  state: string | null
  text: string | null
}

interface NotificationHandlers {
  success: (text: string) => void
  error: (text: string) => void
  info: (text: string) => void
  clear: () => void
}

interface NotificationContext {
  data: NotificationData
  handlers: NotificationHandlers
}

const NotificationContext = createContext<NotificationContext>({} as any)

const initState: NotificationData = {
  state: null,
  text: null
}

const NotificationProvider = ({ children }: { children: ReactNode }) => {
  const [notificationData, setNotificationData] = useState(initState)

  const handlers: NotificationHandlers = {
    success: (text: string) => {
      setNotificationData({ state: STATES.SUCCESS, text: text })
    },

    error: (text: string) => {
      setNotificationData({ state: STATES.ERROR, text: text })
    },

    info: (text: string) => {
      setNotificationData({ state: STATES.INFO, text: text })
    },

    clear: () => {
      setNotificationData(initState)
    }
  }

  return (
    <NotificationContext.Provider value={{ data: notificationData, handlers: handlers }}>
      <Notification />
      {children}
    </NotificationContext.Provider>
  )
}

export { NotificationProvider }
export default NotificationContext
